import * as React from "react";
import { Form, Input } from "antd";
import { BusinessRuleFormFields } from "../../../common/Constants";
import { IBusinessRule } from "../../../model/evaluation/BusinessRule";
import TextArea from "antd/lib/input/TextArea";

const BusinessRuleForm = ({
  getFieldDecorator,
  translate,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: IBusinessRule;
}) => {
  return (
    <Form>
      <Form.Item label={translate("businessRule_form.name")}>
        {getFieldDecorator(BusinessRuleFormFields.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("businessRule_form.required_messages", {
                field: translate("businessRule_form.name")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("businessRule_form.description")}>
        {getFieldDecorator(BusinessRuleFormFields.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description,
          rules: [
            {
              required: true,
              message: translate("businessRule_form.required_messages", {
                field: translate("businessRule_form.description")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>

      <Form.Item label={translate("businessRule_form.rule")}>
        {getFieldDecorator(BusinessRuleFormFields.Fields.RULE, {
          initialValue: rowData && rowData.rule,
          rules: [
            {
              required: true,
              message: translate("businessRule_form.required_messages", {
                field: translate("businessRule_form.rule")
              })
            }
          ]
        })(<TextArea autoSize={{ minRows: 3 }} />)}
      </Form.Item>
    </Form>
  );
};

export default BusinessRuleForm;
